module.exports = __webpack_public_path__ + "static/media/case3B.db41efe.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case3B.mp4
// module id = OVVM
// module chunks = 0